module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-node"
  }, [(_vm.title || _vm.$slots.title) ? _c('div', {
    staticClass: "node-header",
    class: _vm.computedNodeHeaderClass
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._t("icon", function() {
    return [(!_vm.small && _vm.isShowIcon) ? _c('div', {
      class: _vm.computedNodeBgClass
    }, [_c('rt-icon', {
      attrs: {
        "name": _vm.icon,
        "size": "24"
      }
    })], 1) : _c('div')]
  }), _vm._v(" "), _vm._t("title", function() {
    return [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._t("right")], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "node-content",
    class: ['node-content-' + _vm.paddingSize, _vm.contentWrapperClass],
    style: (_vm.contentWrapperStyle)
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d8eae93"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/node/rtNode.vue
// module id = 2099
// module chunks = 228